
import Vue from "vue"
import {
  isHiddenPhone,
  forSpace,
  forBill,
  forCustomer,
  forTax,
  forUser,
  //胡江2个
  forBook,forText,
  forMeal,

  forMall
} from '@libs/http/vuex_http'
export let valueAdd = {
  namespaced:true,
  state:{
    category:{
    },
    form:{ //统计
      space:{},   //存储空间
      bill:{},
      customer:{},
      book:{},
      text:{},
      tax:{},
      meal:{},
      user: {},
      mall: {}
    }
  },
  getters: {
    category: state => state.category,
    formValueAdd: state => state.form
  },
  mutations: {
    changeFormStatic(state, data) {
      state.form[data.type] = data.res
    },
    setCategory(state, data) {
      Vue.set(state.category,data.type,data.info)
    },
  },
  actions: {
    httpForSpace({ commit,getters},par) {
      forSpace(Vue).then(res=>{
        if (res.data.code == '0') {
          commit('changeFormStatic',{ res:res.data.data,type:'space'})
        }
      })
    },
    httpForBill ({ commit,getters}) {
      forBill(Vue).then(res=>{
        if (res.data.code == '0') {
          commit('changeFormStatic',{ res:res.data.data,type:'bill'})
        }
      })
    },
    httpForCustomer ({ commit,getters}) {
      forCustomer(Vue).then(res=>{
        if (res.data.code == '0') {
          commit('changeFormStatic',{ res:res.data.data,type:'customer'})
        }
      })
    },
    httpForBook ({ commit,getters}) {
      forBook(Vue).then(res=>{
        if (res.data.code == '0') {
          commit('changeFormStatic',{ res:res.data.data,type:'book'})
        }
      })
    },
    httpForText ({ commit,getters}) {
      forText(Vue).then(res=>{
        if (res.data.code == '0') {
          commit('changeFormStatic',{ res:res.data.data,type:'text'})
        }
      })
    },
    httpForTax ({ commit,getters}) {
      forTax(Vue).then(res=>{
        if (res.data.code == '0') {
          commit('changeFormStatic',{ res:res.data.data,type:'tax'})
        }
      })
    },
    // 用户数
    httpForUser ({ commit,getters}) {
      forUser(Vue).then(res=>{
        if (res.data.code == '0') {
          commit('changeFormStatic',{ res:res.data.data,type:'user'})
        }
      })
    },

    httpForMeal ({ commit,getters}) {
      forMeal(Vue).then(res=>{
       if (res.data.code == '0') {
         commit('changeFormStatic',{ res:res.data.data,type:'meal'})
       }
      })
    },
    
    httpForMall ({ commit,getters}) {
      forMall(Vue).then(res=>{
       if (res.data.code == '0') {
         commit('changeFormStatic',{ res:res.data.data,type:'mall'})
       }
      })
    }





  }
}
